function LegalFootnotes() {
  return (
    <>
      Kikoff Inc. is a financial technology company “Fin-Tech”, not a bank.
      Banking Services provided by Coastal Community Bank, Member FDIC. FDIC
      insurance only covers the failure of an FDIC-insured bank. FDIC insurance
      is available through pass-through insurance at Coastal Community Bank,
      Member FDIC, if certain conditions have been met. The Kikoff Mastercard®
      is issued by Coastal Community Bank, pursuant to a license from Mastercard
      International Incorporated.
      <br />
      <br />
      <a href="/kikoff-secured-card-agreement" target="_blank">
        Card Agreement
      </a>
      <br />
      <br />
      <sup>1</sup> All other product names, logos, brands, trademarks, and
      registered trademarks are property of their respective owners. All
      company, product, and service names used in this website are for
      identification purposes only. Use of these names, trademarks, and brands
      does not imply endorsement.
      <br />
      <br />
      <sup>2</sup>
      The Kikoff Secured Credit Card Merchant Cash Back Program is governed by
      the Kikoff Merchant Cashback Program Addendum and provided by Coastal
      Community Bank, Member FDIC.&nbsp;
      <a
        href="https://assets.kikoff.com/public/KIKOFF+MERCHANT+CASHBACK+PROGRAM+ADDENDUM+EFFECTIVE+September+15%2C+2022.pdf"
        target="_blank"
        rel="noreferrer"
      >
        Learn More
      </a>
      <br />
      <br />
      <sup>3</sup> Direct deposit required to unlock overdraft protection.
      Overdraft limit is determined by card usage and other risk factors.
      <br />
      <br />
      <sup>4</sup> Early access to direct deposit funds depends on the timing of
      the payer’s submission of deposits and is not guaranteed.
      <br />
      <br />
      <sup>5</sup> The Kikoff Secured Credit Card reports to Equifax, Experian
      and TransUnion on a monthly basis. Minimum deposit of $50 is required to
      be reported to the credit bureaus.
      <br />
      <br />
      <sup>6</sup> Fee-Free ATMs get fee-free transactions at any Allpoint ATM.
      Otherwise, out-of-network ATM withdrawal fees may apply.
      <br />
      <br />
      <sup>7</sup> Mastercard Fraud Liability:&nbsp;
      <a
        href="https://www.mastercard.us/en-us/personal/get-support/zero-liability-terms-conditions.html"
        target="_blank"
        rel="noreferrer"
      >
        Learn more
      </a>
    </>
  );
}

export default LegalFootnotes;
